import { render, staticRenderFns } from "./CCTrules.vue?vue&type=template&id=4a19765d&scoped=true"
import script from "./js/CCTrules.js?vue&type=script&lang=js&external"
export * from "./js/CCTrules.js?vue&type=script&lang=js&external"
import style0 from "./css/CCTrules.scss?vue&type=style&index=0&id=4a19765d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a19765d",
  null
  
)

export default component.exports